import axios from "./index";

class DatosBasicosApi {
  static fetchClasesDeuda = () => {
    return axios.get(`/datosbasicos/clasesDeuda/`);
  };
  static fetchEstadosProceso = () => {
    return axios.get(`/datosbasicos/estadosProceso/`);
  };
  static fetchParametrosGenerales = () => {
    return axios.get(`/datosbasicos/parametrosGenerales/`);
  };
  static fetchParametrosValores = () => {
    return axios.get(`/datosbasicos/parametrosGenerales/valores/`);
  };
  static fetchParametroByValor = (valor) => {
    return axios.get(`/datosbasicos/parametrosGenerales/${valor}/consultar/`);
  };
  static fetchTiposNovedad = () => {
    return axios.get(`/datosbasicos/tiposNovedad/`);
  };
  static fetchTiposProceso = () => {
    return axios.get(`/datosbasicos/tiposProceso/`);
  };
  static fetchTiposProcesoActivos = () => {
    return axios.get(`/datosbasicos/tiposProceso/activos/`);
  };
  static fetchDiasFestivos = () => {
    return axios.get(`/datosbasicos/diasFestivos/`);
  };
  // Módulo de Configuración
  static fetchConfigParametros = () => {
    return axios.get(`/datosbasicos/configuracion/parametros/`);
  };
  static createConfigParametro = (data) => {
    return axios.post(`/datosbasicos/configuracion/parametros/`, data);
  };
  static updateConfigParametro = (id, data) => {
    return axios.put(`/datosbasicos/configuracion/parametros/${id}/`, data);
  };
  static fetchSalasZoom = () => {
    return axios.get(`/datosbasicos/configuracion/salasZoom/`);
  };
  static fetchSalasZoomActivas = () => {
    return axios.get(`/datosbasicos/configuracion/salasZoom/`, { params: { activas: "true" } });
  };
  static createSalaZoom = (data) => {
    return axios.post(`/datosbasicos/configuracion/salasZoom/`, data);
  };
  static updateSalaZoom = (codigo, data) => {
    return axios.put(`/datosbasicos/configuracion/salasZoom/${codigo}/`, data);
  };
}

export default DatosBasicosApi;
